import { render, staticRenderFns } from "./ModalFormularioDadosPerfil.vue?vue&type=template&id=2293867a&"
import script from "./ModalFormularioDadosPerfil.vue?vue&type=script&lang=js&"
export * from "./ModalFormularioDadosPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports